import PropTypes from "prop-types";
import labels from "../../../config/labels";
import Image from "../image/image";
import config from "../../../config/index";
import styles from "./ErrorInformation.module.scss";
import * as Analytics from "../../../services/analyticsUtag";
import { maskMsisdn } from "../../../services/upgradeService";
import {
  getClearCartQuery,
  showSpinner,
  hideSpinner,
  getCookieValue,
} from "../../../utils/helperServices";
import ajaxService from "../../../utils/ajaxServices";
import { showGuestCart } from "../../../Redux/actions/cartAction";
import { connect } from "../../../components/atoms/DependencyHelper";

const ErrorInformation = ({
  type,
  title,
  subtitle,
  desc,
  btnLabel,
  className,
  id,
  onClickHandler,
  formName,
  multicartFlag,
  phoneNumber,
  selectedPreference,
  dealProducts,
  showGuestCart,
}) => {
  const cartId = getCookieValue("cart_id");
  let defaultTitle,
    defaultBtnLabel,
    secondaryBtnLabel,
    btnType,
    btnTypeSecondary,
    primaryUrl = "/",
    secondaryUrl = "/";

  switch (type) {
    case "default":
      defaultTitle = labels.errors.lbl_something_went_wrong;
      defaultBtnLabel = "Try again";
      break;
    case "success":
      if (multicartFlag || selectedPreference === "all-above") {
        btnType = null;
        if (selectedPreference === "all-above") {
          primaryUrl = "/checkout";
          defaultBtnLabel = labels.lbl_continue_with_checkout;
          secondaryBtnLabel = labels.lbl_exit_checkout.desktop;
          btnTypeSecondary = "success-exit";
        } else {
          primaryUrl = "/";
          defaultBtnLabel = labels.lbl_exit_checkout.desktop;
        }
      } else {
        defaultTitle = labels.errors.lbl_contact_soon;
        defaultBtnLabel = "Go to home page";
        btnType = "success-btn";
      }
      break;
    case "submit-error":
      defaultTitle = labels.errors.lbl_form_not_submitted;
      desc = labels.errors.lbl_try_again;
      defaultBtnLabel = "Go to home page";
      btnType = "outline-black";
      break;
    case "otp-error":
      defaultTitle = labels.upgrade.lbl_invalid_otp_try_3_title;
      desc = labels.upgrade.lbl_invalid_otp_try_3_btn_title;
      defaultBtnLabel = "Go to home page";
      btnType = "outline-black";
      break;
    default:
      defaultTitle = labels.errors.lbl_technical_issue;
      defaultBtnLabel = "Exit";
      break;
  }

  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  const formType = type === "success" ? type : "error";

  const buttonClicked = async (event, url, btnType) => {
    event.preventDefault();
    Analytics.link({
      link_type: "o",
      link_name: `shopping: forms: ${formName}: ${formType}: ${defaultBtnLabel}`,
      page_name: `shopping: forms: ${formName}: ${formType}`,
      page_form_name: `shopping: forms: ${formName}`,
    });

    if (
      btnType == "primary" &&
      dealProducts &&
      dealProducts.length > 0 &&
      multicartFlag &&
      selectedPreference === "all-above"
    ) {
      //delete deals products before redirecting user to normal checkout page
      const dealProductsIds = dealProducts.map((item) => item?.id);
      showSpinner();
      let query = getClearCartQuery(dealProductsIds);
      await ajaxService.fetchGraphQLPOSTRequest(query);
      await showGuestCart(cartId);
      hideSpinner();
    }

    if (onClickHandler) {
      onClickHandler({ type, url });
    }
  };

  if (type === "success") {
    Analytics.view({
      page_event: "view",
      page_name: `shopping: forms: ${formName}: success`,
      page_form_name: `shopping: forms: ${formName}`,
      page_form_event: "success",
      multicart_flag: multicartFlag ? true : false,
    });
  } else {
    Analytics.view({
      page_event: "view",
      page_name: `shopping: forms: ${formName}: error`,
      page_errors: `${title ? title : defaultTitle}. ${desc}`,
      page_error_type: "form",
      page_form_name: `shopping: forms: ${formName}`,
      page_form_event: "error",
      multicart_flag: multicartFlag ? true : false,
    });
  }

  return (
    <div className={`${styles["main-container"]} ${className}`}>
      <div className={styles["icon"]}>
        <Image
          img_path={
            type === "success"
              ? `${imagePrefix}/assets/images/success-circle.svg`
              : `${imagePrefix}/assets/images/error-warning-red.svg`
          }
        />
      </div>
      <div className={styles["title"]}>{title ? title : defaultTitle}</div>
      {desc && (
        <div className={styles["desc"]}>
          {desc} {maskMsisdn(phoneNumber)}
        </div>
      )}
      {subtitle && (
        <div className={styles["subtitle"]}>
          <hr className={styles["subtitle-separator"]} />
          <p className={styles["subtitle"]}>{subtitle}</p>
        </div>
      )}
      <div className={styles["button-wrapper"]}>
        <button
          id={`error-btn-${type}-${id}`}
          className={`${styles["button"]} ${styles[type]} ${styles[btnType]}`}
          onClick={(event) => {
            buttonClicked(event, primaryUrl, "primary");
          }}
        >
          {btnLabel ? btnLabel : defaultBtnLabel}
        </button>
        {secondaryBtnLabel && (
          <button
            id={`error-btn-${type}-${id}-secondary`}
            className={`${styles["button"]} ${styles[btnTypeSecondary]}`}
            onClick={(event) => {
              buttonClicked(event, secondaryUrl, "secondary");
            }}
          >
            {secondaryBtnLabel}
          </button>
        )}
      </div>
    </div>
  );
};

ErrorInformation.propTypes = {
  type: PropTypes.string,
  title: PropTypes.string,
  desc: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.string,
  btnLabel: PropTypes.string,
  onClickHandler: PropTypes.func,
  formName: PropTypes.string,
  phoneNumber: PropTypes.string,
};

ErrorInformation.defaultProps = {
  type: "default",
  id: "0",
};

export default connect(null, {
  showGuestCart,
})(ErrorInformation);
